import { makeStyles } from '@mui/styles'
import { BORDERRADIUS as borderRadius } from "@fedsim/constants"

export const useListStyles = makeStyles(theme => {
  return {
    root: {
      borderRadius,
      overflow: 'hidden'
    },
    selected: {
      margin: theme.spacing(0.4, 0)
    },
    listItem: {
      backgroundColor: 'black',
      backgroundImage: 'radial-gradient(rgba(0, 0, 0, 0.4) 0.5px, transparent 0.5px)',
      backgroundSize: '15px 15px',
      color: 'white'
    },
    container: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      minWidth: 320,
      width: '100%',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        width: '100%'
      }
    },
    list: {
      overflow: 'hidden'
    },
    presentation: { 
      display: 'flex',
      alignItems: 'center',
      transition: '1s ease-out',
      overflow: 'hidden',
      flex: 1,
      '&:hover': {
        transform: 'translateY(2px)'
      },
      [theme.breakpoints.down('md')]: {
        width: '100%'
      }
    },
    actions: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      '& button': {
        maxWidth: '180px'
      }
    }
  }
})
